import React, { Component } from 'react';
import Header from '../../.././Header';
import Image from '../../.././Image';
import classnames from 'classnames';

export default class Growth extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"},
      {path: "/projects/quora", title: "Quora"}
    ]

    return (
      <div className={classnames('Growth', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">Growth</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Driving growth and retention by optimizing the signup process</li>
                  <li><strong>Role</strong>: Product designer</li>
                  <li><strong>Duration</strong>: Jun 2013—Dec 2013 (6 months)</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  Coming soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/Quora/Growth/index.js